export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./update/${this.updateId}/whats-new.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/whats-new.controller.js